export const limits = {
    ignorePermanentChange: false,
};
